import {useIntl} from 'react-intl'
import {MenuItem} from './MenuItem'
import {MenuInnerWithSub} from './MenuInnerWithSub'
import {MegaMenu} from './MegaMenu'
import {useAuth} from '../../../../../app/modules/auth'
import {hasAuthority} from '../../../../../app/modules/utils/Permission'
import {UserModelLogin} from '../../../../../app/modules/auth/core/_models'
export function MenuInner() {
  const intl = useIntl()
  const {currentUser} = useAuth()
  const userWithAuthorities = currentUser as UserModelLogin
  return (
    <>
      <MenuInnerWithSub
        title={intl.formatMessage({id: 'MENU.TASK'})}
        to='/task'
        menuPlacement='bottom-start'
        menuTrigger='click'
      >
        {hasAuthority('REPORT.STAFF.VIEW') && (
          <MenuItem
            icon='/media/icons/duotune/general/gen051.svg'
            to='/task/employee'
            title={intl.formatMessage({id: 'MENU.TASK.EMPLOYEE'})}
          />
        )}
        {hasAuthority('REPORT.VIEW') && (
          <MenuItem
            icon='/media/icons/duotune/general/gen051.svg'
            to='/task/others'
            title={intl.formatMessage({id: 'MENU.TASK.OTHER'})}
          />
        )}
      </MenuInnerWithSub>
      {hasAuthority('TIMEKEEPING.VIEW') && (
        <MenuItem title={intl.formatMessage({id: 'MENU.TIMEKEEPING'})} to='/timekeeping' />
      )}
      {hasAuthority('PROGRESS.VIEW') && (
        <MenuItem title={intl.formatMessage({id: 'MENU.REPORT'})} to='/report' />
      )}
      <MenuInnerWithSub
        title={intl.formatMessage({id: 'MENU.CATEGORY'})}
        to='/category'
        menuPlacement='bottom-start'
        menuTrigger='click'
      >
        {hasAuthority('PROJECT.VIEW') && (
          <MenuItem
            icon='/media/icons/duotune/general/gen051.svg'
            to='/category/project'
            title={intl.formatMessage({id: 'MENU.CATEGORY.PROJECT'})}
          />
        )}
        {hasAuthority('TEAM.VIEW') && hasAuthority('MEMBER.VIEW') && (
          <MenuItem
            icon='/media/icons/duotune/general/gen051.svg'
            to='/category/personnel'
            title={intl.formatMessage({id: 'MENU.CATEGORY.PERSONNEL'})}
          />
        )}
      </MenuInnerWithSub>
      {hasAuthority('USER.VIEW') && (
        <MenuInnerWithSub
          title={intl.formatMessage({id: 'MENU.ADMINISTRATION'})}
          to='/administration'
          menuPlacement='bottom-start'
          menuTrigger='click'
        >
          <MenuItem
            icon='/media/icons/duotune/general/gen051.svg'
            to='/administration/user'
            title={intl.formatMessage({id: 'MENU.ADMINISTRATION.USER'})}
          />
        </MenuInnerWithSub>
      )}
    </>
  )
}
